<div *ngIf="apiInProcess" class="text-center mt-4">
  <img src="assets/themes/images/img-video-loader.gif" width="40" alt="loader" />
</div>
